import { render, staticRenderFns } from "./createform.vue?vue&type=template&id=0cd30e3c&scoped=true"
import script from "./createform.vue?vue&type=script&lang=js"
export * from "./createform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd30e3c",
  null
  
)

export default component.exports